import Extension from "../base/extension";

class ApiGeoapify extends Extension {
  apiKey;

  constructor(name) {
    super(name);
  }

  async onReady(){
    try {
      let result = await this.getUserGeoData();
      let geodataJSON = JSON.parse(result);
      if(geodataJSON.error){
        console.warn(this.logPrefix, "Error getting location");
        return;
      }

      // Dispatch a CustomEvent for other extensions to listen for / react to
      let event = new CustomEvent("geodata:loaded", {
        detail: {
          data: geodataJSON
        }
      });
      document.dispatchEvent(event);
    } catch (error) {
      // console.warn(this.logPrefix, error);
    }
  }

  /**
   * Get either cached or fresh geolocation data. If not cached, store as cookie
   * 
   * @returns {Promise} a Promise
   */
  getUserGeoData() {
    if(Cookies.get('mp-geo') === undefined) {
      return this.fetchUserGeoData();
    } else {
      return Promise.resolve(Cookies.get("mp-geo"));
    }
  }

  /**
   * Get the current user's geographic data from their IP via Geoapify
   * @returns {Promise}
   */
  async fetchUserGeoData() {
    if(!this.apiKey){
      return Promise.reject("No API key specified");
    }

    try {
      let response = await fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=" + this.apiKey, {method: 'GET'});
      let result = await response.json();
      Cookies.set("mp-geo", JSON.stringify(result));
      return JSON.stringify(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default ApiGeoapify;